
import { iterate } from "../../fable-library-js.5.3.0/Seq.js";
import { disposeSafe } from "../../fable-library-js.5.3.0/Util.js";
import { toArray } from "../../fable-library-js.5.3.0/Option.js";

export function Helpers_optDispose(disposeOption) {
    return {
        Dispose() {
            iterate((d) => {
                let copyOfStruct = d;
                disposeSafe(copyOfStruct);
            }, toArray(disposeOption));
        },
    };
}

export function Interop_setKeyOnObj(withKey, props) {
    if (withKey == null) {
        return props;
    }
    else {
        const f = withKey;
        props.key = f(props);
        return props;
    }
}

//# sourceMappingURL=Helpers.fs.js.map
